<template>
    <main-content v-if="$can('read', 'deposit-gateway')">
        <manage-deposit-pf v-if="this.$route.params.gateway_source === 'pf'"></manage-deposit-pf>
        <manage-deposit-starshop v-if="this.$route.params.gateway_source === 'starshop'"></manage-deposit-starshop>
    </main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import {mapGetters} from 'vuex'
import ManageDepositPf from './components/manage-deposit-pf.vue'
import ManageDepositStarshop from './components/manage-deposit-starshop.vue'

export default {
    components: {
        'main-content': mainContent,
        'manage-deposit-pf': ManageDepositPf,
        'manage-deposit-starshop': ManageDepositStarshop
    },
    data() {
        return {
            headerAction: {
                left: '10px',
                top: '10px',
                position: 'absolute',
            },
        }
    },
}
</script>

<style>

</style>